export default {
    init() {
        this.auctionListShowMore();
        this.auctionFilterSlider();
    },

    auctionListShowMore(){
        $('.auctions-list--item-row--show-more').on('click',function(){
            let parentElement = $(this).parent().parent();
            let showElement = parentElement.find('.auctions-list--item-row--log-hidden');
            if(parentElement.hasClass('active')){
                parentElement.removeClass('active');
                showElement.slideUp(300);
            } else {
                parentElement.addClass('active');
                showElement.slideDown(300);
            }
        });
    },

    auctionFilterSlider(){
        $('.lots-list--helpers--tags-row').slick({
            infinite: true,
            slidesToShow: 6,
            arrows: true,
        });
    },
}